import { api } from './client';

export const LocationsAPI = {
  getCountries: () => api.get('/locations/countries'),
  getStates: (countryCode) => api.get(`/locations/countries/${countryCode}/states`),
  getCities: (countryCode, stateCode = null) => 
    stateCode 
      ? api.get(`/locations/countries/${countryCode}/states/${stateCode}/cities`)
      : api.get(`/locations/countries/${countryCode}/cities`)
};

export default LocationsAPI;
